'use client'

import { useMemo } from 'react'
import useSWR from 'swr/immutable'
import { axios } from '@/configs'
import { useCustomRouter } from '@/root/shared-hooks'
import type { Country } from '@/root/shared-types/companyInfoPage/company-info-types'
import type { SelectOption } from '@/root/modules/shared/ConfirmPage/types'

const fetchCountries = async (url: string): Promise<Country[]> => {
  const response = await axios.get<{ items: Country[] }>(url)
  return response.data?.items ?? []
}

/** All countries of the catalog as select options; a country without `titles` is labelled by its `title`. */
export const useCountryOptions = () => {
  const { locale } = useCustomRouter()

  const { data: countriesData, isLoading } = useSWR('get-countries/countries', fetchCountries)

  const countries: SelectOption[] = useMemo(() => {
    if (!countriesData) return []
    return countriesData.map((country) => ({
      code: country.code,
      label: country.titles?.[locale] ?? country.titles?.en ?? country.title,
    }))
  }, [countriesData, locale])

  return { countries, isLoading }
}
